import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9 7a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-5a5 5 0 1 0 0 10 5 5 0 0 0 0-10M8 14a5 5 0 0 0-5 5v2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-2a5 5 0 0 0-5-5zm-2.121 2.879A3 3 0 0 1 8 16h8a3 3 0 0 1 3 3v1H5v-1a3 3 0 0 1 .879-2.121",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }